import { flatten } from 'lodash'
import React from 'react'

import { isConsole } from '../../config/config'
import { useJobByHumanId } from '../../hooks/query/useJobByHumanId'
import { ExternalLink } from '../ExternalLink/ExternalLink'

interface NoteTextProps {
  text: string
}

// Avoid using `dangerouslySetInnerHTML` as it can introduce XSS
export function NoteText({ text }: NoteTextProps) {
  let textParts: (string | JSX.Element)[] = [text]

  textParts = flatten(textParts.map((t) => processGenericUrl(t)))
  textParts = flatten(textParts.map((t) => processJobUrl(t)))

  if (isConsole()) {
    textParts = flatten(textParts.map((t) => processZendesk(t)))
  }

  return (
    <>
      {textParts.map((t, idx) => (
        <React.Fragment key={idx}>{t}</React.Fragment>
      ))}
    </>
  )
}

const URL_REGEXP =
  /(https?:\/\/[www]?\.?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&//=]*)/
function processGenericUrl(s: string | JSX.Element) {
  if (typeof s !== 'string') return s

  return s.split(URL_REGEXP).map((s) =>
    s.match(URL_REGEXP) ? (
      <ExternalLink href={s.trim()} variant="label3">
        {s}
      </ExternalLink>
    ) : (
      s
    )
  )
}

const ZENDESK_REGEXP = /(?<!(?:trailer|truck):?\s?)(#\s?[0-9]+)/gi
function processZendesk(s: string | JSX.Element) {
  if (typeof s !== 'string') return s

  return s.split(ZENDESK_REGEXP).map((s) =>
    s.match(ZENDESK_REGEXP) ? (
      <ExternalLink
        href={`https://cloudtrucks.zendesk.com/agent/tickets/${s.replace('#', '').trim()}`}
        variant="label3"
      >
        {s}
      </ExternalLink>
    ) : (
      s
    )
  )
}

const JOB_REGEXP = /([0-9a-zA-Z]{4}-[0-9a-zA-Z]{4})/
function processJobUrl(s: string | JSX.Element) {
  if (typeof s !== 'string') return s

  return s.split(JOB_REGEXP).map((s) => (s.match(JOB_REGEXP) ? <JobLink humanId={s.trim()} /> : s))
}

function JobLink({ humanId }: { humanId: string }) {
  const { job } = useJobByHumanId(humanId)

  if (!job) return <>{humanId}</>

  return (
    <ExternalLink href={isConsole() ? `/jobs/${job.id}/show` : `/jobs/details/${job.id}/`} variant="label3">
      {humanId}
    </ExternalLink>
  )
}
